import { render, staticRenderFns } from "./HotLeadsItem.vue?vue&type=template&id=46819e2e&"
import script from "./HotLeadsItem.vue?vue&type=script&lang=js&"
export * from "./HotLeadsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports